import { Tabs } from "antd";
import GiftcardRequest from "./giftcard";
import GiftCardRequestHistory from "./GiftCardRequestHistory";

const items = [
  {
    key: "1",
    label: "New Request",
    children: <GiftcardRequest />,
  },
  {
    key: "2",
    label: "Pending Request",
    children: <GiftCardRequestHistory />,
  },
];

const RequestTabs = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default RequestTabs;
